import { Component, computed, input, OnChanges, signal, SimpleChanges } from "@angular/core";
import { IrbSubscriptionDetailsType } from "../../../gql/generated-ingestor";
import {
  AggspSubscriptionDetails,
  MscSubscriptionDetails,
  ServicePortSubscriptionDetails,
  ServiceType,
} from "../../../pages/subscription-detail/types";
import { TranslateModule } from "@ngx-translate/core";
import { PortVisualiser } from "../port-visualiser/port-visualiser";
import { AngularSvgIconModule } from "angular-svg-icon";
import { ServiceSummaryComponent } from "../service-summary/service-summary";
import { ServiceRowComponent } from "./components/service-row/service-row";

@Component({
  selector: "subscription-detail-container",
  templateUrl: "subscription-detail-container.html",
  imports: [AngularSvgIconModule, PortVisualiser, ServiceRowComponent, ServiceSummaryComponent, TranslateModule],
})
export class SubscriptionDetailContainer implements OnChanges {
  protected subscription = input.required<
    ServicePortSubscriptionDetails | MscSubscriptionDetails | AggspSubscriptionDetails | IrbSubscriptionDetailsType
  >();
  protected services = computed(() => this.subscription().services);

  protected activeSubscription = signal<ServiceType>(undefined);

  protected activeSubscriptionVlanranges = computed(() => [Number(this.activeSubscription().vlanrange)]);
  protected tags = computed(() => this.subscription().tags);
  protected activeSubscriptionId = computed(() => this.activeSubscription()?.subscriptionId);
  protected portId = computed(() =>
    this.activeSubscription().product.type === "Port" ? this.activeSubscriptionId() : null,
  );

  ngOnChanges(changes: SimpleChanges) {
    if (!this.activeSubscription() && this.services().length > 0) {
      this.activeSubscription.set(this.services()[0]);
    }
  }

  setActiveSubscription(sub) {
    this.activeSubscription.set(sub);
  }

  OnClickBar(subscriptionId) {
    const findSubscription = this.services().find((x) => x.subscriptionId === subscriptionId);
    this.setActiveSubscription(findSubscription);
  }
}
